import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.ADVERTISER };

export const GetCommonAttributeList = async (values) => {
  return await axiosInstance(options).post(`common/product-attribute-list`, values);
};
